<template>
  <div class="vip-header"></div>
</template>
<script>
export default {
  created() {
    if (this.jsBridge.isApp) {
      this.jsBridge.dispatch('hideAppNavbar', {isOnlyGoBackWeb: '0'});
      this.jsBridge.dispatch('setAppStatusBarColor', '0');
    }
  },
  methods: {
    onBack() {
      this.jsBridge.dispatch('goBackApp');
    },
    onShare() {
     
      this.jsBridge.dispatch('appShare');
    }
  }
};
</script>
<style lang="scss" scoped>
.vip-header {
  margin-bottom: 18px;
  background-color: #21232a;
  &__ctn {
    position: relative;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #c59f6d;
  }
  h3 {
    font-size: 24px;
  }
  button {
    display: none;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    border: none;
    background-color: transparent;
    outline: none;
    padding-left: 18px;
    padding-right: 18px;
  }
  .nav {
    left: 0;
  }
  .share {
    right: 0;
  }
}
@media screen and (max-width: 768px) {
  .vip-header {
    margin-bottom: 0;
    button {
      display: block;
    }
    &.is-app {
      padding-top: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// VipInnerHeader.vue?4154b8ba